import type {
  ButtonType,
  TemplateType,
} from '@src/components/AdminHome/Channels/WhatsApp/WhatsAppTemplates/types';

// eslint-disable-next-line no-shadow
export enum WhatsAppFlowStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  DEPRECATED = 'DEPRECATED',
  BLOCKED = 'BLOCKED',
  THROTTLED = 'THROTTLED',
}

export type WhasAppFlowItem = {
  id: string;
  name: string;
  status: WhatsAppFlowStatus;
  wabaId?: string;
};

export type WhasAppFlowTemplate = {
  botAccountId: number;
  name: string;
  templateUse: 'BROADCAST';
  category: 'MARKETING';
  language: 'es';
  message: string;
  components: unknown[];
};

export type WhatsAppFlowsFilters = {
  phoneNumber: string;
  name?: string;
  status?: WhatsAppFlowStatus[];
  limit?: string;
  offset?: string;
};

export type WhatsAppFlowResponsesFilters = {
  // eslint-disable-next-line camelcase
  start_time?: string;
  // eslint-disable-next-line camelcase
  end_time?: string;
  limit?: string;
  offset?: string;
};

export type ResponsesByFlowTokenFieldResponse = {
  name: string;
  value: string;
};

export type ResponsesByFlowTokenScreen = {
  // eslint-disable-next-line camelcase
  screen_name: string;
  // eslint-disable-next-line camelcase
  field_responses: ResponsesByFlowTokenFieldResponse[];
};

export type ResponsesByFlowToken = {
  // eslint-disable-next-line camelcase
  flow_name: string;
  // eslint-disable-next-line camelcase
  response_date: string;
  screens: ResponsesByFlowTokenScreen[];
};

// eslint-disable-next-line no-shadow
export enum TemplateWithFlowContentTypes {
  BODY = 'BODY',
  BUTTONS = 'BUTTONS',
}

type TemplateWithFlowContentButtons = {
  text: string;
  // Any template button the backend forwards inside the BUTTONS block, plus Meta's
  // request-contact-info button, which the console models as a TemplateType.
  type: ButtonType | TemplateType.REQUEST_CONTACT_INFO;
};

export type TemplateWithFlowContent = {
  type: TemplateWithFlowContentTypes;
  text?: string;
  buttons?: TemplateWithFlowContentButtons[];
}[];
